<header>  
  <div class="logo">
    <img src="/images/wgc/logos/wg-logo-color.svg" alt="Watchguard logo">
  </div>
</header>
<h1>Public API Catalog</h1>